import { type CarrierDef } from '../common.js'

const credentialTypes = [] as const

export type tmkaCredType = (typeof credentialTypes)[number]

export const tmka: CarrierDef<tmkaCredType> = {
  name: 'Tumalo Creek',
  scac: 'tmka',
  credentialTypes,
  engineLayers: ['tracking'],
}
